"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EWebSocketMessage = void 0;
var EWebSocketMessage;
(function (EWebSocketMessage) {
    EWebSocketMessage["VEHICLE_TABLE_UPDATE"] = "sales_updateVehicleData";
    EWebSocketMessage["OPPORTUNITY_UPDATE"] = "OpportunityUpdate";
    EWebSocketMessage["NOTIFICATION"] = "notification";
})(EWebSocketMessage = exports.EWebSocketMessage || (exports.EWebSocketMessage = {}));
